<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
        <v-col cols="12" md="4">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1 mb-2">Kits</div>
                <div class="text text--thin mb-2">Os kits incluídos aqui são exibidos no cadastro de produtos</div>
                <v-btn v-if="!$root.Permissions.admin() && !$root.Permissions.revendor()" @click="dialog = true" color="primary" class="mt-1"><v-icon class="mr-1">fact_check</v-icon>Novo kit</v-btn>
              </v-col>
              <v-col cols="12" md="5" v-if="!$root.Permissions.admin() && !$root.Permissions.revendor()">
                <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                  <v-icon>add</v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        disable-sort
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <v-row no-gutters>
              <div class="py-2 px-2">
                <v-form @submit.prevent="applyFilter()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
              </div>
              <div class="py-2 px-2" v-if="!$root.Permissions.distributor()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="distribuidorSelecionado"
                  :items="distribuidores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Distribuidor"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </div>
              <div class="py-2 px-2" v-if="!$root.Permissions.integrator() && !$root.Permissions.distributor()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="integradorSelecionado"
                  :items="integradores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Integrador"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </div>
            </v-row>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  {{ validaPermissaoEditarExcluir(item) ? 'edit' : 'visibility' }}
                </v-icon>
              </template>
              <span>{{ validaPermissaoEditarExcluir(item) ? 'Editar' : 'Ver kit' }}</span>
            </v-tooltip>
            <v-tooltip top v-if="validaPermissaoEditarExcluir(item)">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="850px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{validaPermissaoEditarExcluir(kit) ? kit.uuid_kit_id ? 'Editar kit' : 'Novo kit' : kit.kit_nome}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formKits">
          <v-tabs
            next-icon="chevron_right"
            prev-icon="chevron_left"
            show-arrows
            class="ui-tabs"
            v-model="tabs">
            <v-tab>
              <v-icon>fact_check</v-icon> Dados do kit
            </v-tab>
            <v-tab>
              <v-icon>shopping_cart</v-icon> Produtos
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs" class="ui-tabs-inherit mb-2">
            <v-tab-item class="px-1 pb-1">
              <v-card class="px-3">
                <v-row class="mt-0">
                  <v-col cols="12" sm="12" md="9" lg="9" xl="9" class="pb-0">
                    <v-text-field
                      v-model="kit.kit_nome"
                      label="Nome*"
                      :rules="[rules.required]"
                      autofocus
                      outlined
                      :disabled="salvando"
                      :loading="salvando"
                      :readonly="!validaPermissaoEditarExcluir(kit)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pb-0">
                    <v-text-field
                      v-model="kit.kit_referencia"
                      label="Referência"
                      outlined
                      :disabled="salvando"
                      :loading="salvando"
                      :readonly="!validaPermissaoEditarExcluir(kit)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
                    <v-textarea
                      outlined
                      rows="3"
                      v-model="kit.kit_descricao"
                      :loading="salvando"
                      :disabled="salvando"
                      :readonly="!validaPermissaoEditarExcluir(kit)"
                      label="Descrição"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item class="px-1 pb-1">
              <v-card class="px-3 pt-2 pb-2 mb-3" style="min-height: 100px">
                <v-row no-gutters align="center" justify="space-between" class="mt-2">
                  <div class="text-h2">
                    <span v-if="distribuidor.uuid_dis_id && distribuidores.length > 0 && !$root.Permissions.distributor()">
                      <b>
                        {{(distribuidores.filter(item => item.value === distribuidor.uuid_dis_id))[0].text}}
                      </b>
                      <v-tooltip top v-if="validaPermissaoEditarExcluir(this.kit)">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" @click="dialogAlterarDistribuidor = true" color="primary" class="ml-1">
                            edit
                          </v-icon>
                        </template>
                        <span>Alterar distribuidor</span>
                      </v-tooltip>
                    </span>
                  </div>
                  <div>
                    <v-btn
                      v-if="validaPermissaoEditarExcluir(this.kit)"
                      color="primary"
                      @click="openDialogDistribuidor()"
                      :loading="salvando"
                      :disabled="salvando"
                    >
                      Adicionar produto
                    </v-btn>
                  </div>
                </v-row>
                <v-row justify="end" class="w-100 pt-2 pb-1">
                  <v-badge
                    v-for="item in categoriasProdutos"
                    :key="item.value"
                    :content="item.quantidade"
                    :value="item.quantidade"
                    overlap
                    color="orange accent-3"
                  >
                    <v-chip small label :color="item.color" class="ml-3 mb-2" text-color="white">
                      {{ item.text }}
                    </v-chip>
                  </v-badge>
                </v-row>
                <v-data-table
                  :headers="headersProdutos"
                  :items="dadosProdutos"
                  loading-text="Carregando... Por favor aguarde"
                  :loading="carregando"
                  class="elevation-1 base_table mt-4 mb-1"
                  :hide-default-footer="true"
                  :items-per-page="-1"
                  :header-props="{
                    sortIcon: 'north',
                  }"
                >
                  <template v-slot:item.pro_categoria="{ item }">
                    <v-chip small label :color="retornaCategoria(item).color" class="orcamento_chip" text-color="white">
                      {{ retornaCategoria(item).text }}
                    </v-chip>
                  </template>
                  <template v-slot:item.pro_preco_venda="{ item }">
                    {{item.pro_valor_tabela ? $root.Formatter.floatToMoney(item.pro_valor_tabela) : $root.Formatter.floatToMoney(item.pro_preco_venda)}}
                  </template>
                  <template v-slot:item.total="{ item }">
                    {{item.pro_valor_tabela ? $root.Formatter.floatToMoney(item.pro_valor_tabela * item.pro_quantidade) : $root.Formatter.floatToMoney(item.pro_preco_venda  * item.pro_quantidade)}}
                  </template>
                  <template v-slot:item.pro_quantidade="{ item }">
                    <v-row no-gutters align="center" justify="start">
                      <v-icon v-if="validaPermissaoEditarExcluir(kit)" @click="diminuiQuantidadeProduto(item)">do_not_disturb_on</v-icon>
                      <span class="px-2">{{item.pro_quantidade}}</span>
                      <v-icon v-if="validaPermissaoEditarExcluir(kit)" @click="aumentaQuantidadeProduto(item)">add_circle</v-icon>
                    </v-row>
                  </template>
                  <template v-slot:item.actions="{ item }" v-if="validaPermissaoEditarExcluir(kit)">
                    <v-row no-gutters align="center" justify="center">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" @click="confirmaRemoveProduto(item)" color="primary" class="ml-2">
                            delete
                          </v-icon>
                        </template>
                        <span>Remover</span>
                      </v-tooltip>
                    </v-row>
                  </template>
                </v-data-table>
                <v-row no-gutters  justify="space-between">
                  <v-col cols="12" sm="6">
                    <p class="pt-4 text-h6 mt-2">
                      Valor total em produtos: <span class="text-h6 font-weight-bold">{{$root.Formatter.floatToMoney(totalKit)}}</span>
                    </p>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <vuetify-money
                      class="mt-4"
                      label="Valor do kit*"
                      lazy-validation
                      v-model="kit.kit_valor"
                      :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                      :disabled="salvando"
                      :loading="salvando"
                      outlined
                      :options="optionsMoney"
                      valueWhenIsEmpty=""
                      :rules="[rules.required]"
                      :readonly="!validaPermissaoEditarExcluir(kit)"
                    ></vuetify-money>
                  </v-col>
                </v-row>
              </v-card>
              <v-dialog v-model="dialogRemoveProduto" max-width="400">
                <v-card class="ui-dialog-top">
                  <v-row align="center" justify="space-between">
                    <v-col cols="10">
                      Remover produto
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <v-icon @click="dialogRemoveProduto = false">close</v-icon>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card class="ui-dialog-content">
                  <div class="mb-5">
                    Tem certeza que deseja remover o produto <b>{{produtoRemover.pro_nome}}</b>?
                  </div>
                  <v-divider class="mb-3"></v-divider>
                  <v-row
                    align="center"
                    justify="space-between"
                    class="px-5 py-5"
                  >
                    <v-btn
                      color="cancel"
                      :loading="salvando"
                      :disabled="salvando"
                      @click="dialogRemoveProduto = false"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="success"
                      :loading="salvando"
                      :disabled="salvando"
                      @click="removeProdutoLista()"
                    >
                      Remover
                    </v-btn>
                  </v-row>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="dialogSelecionaProduto"
                persistent
                max-width="1100px"
              >
                <v-card class="ui-dialog-top">
                  <v-row align="center" justify="space-between">
                    <v-col cols="10">
                      Selecionar produtos
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <v-icon @click="closeDialogProdutosSemCadastro()">close</v-icon>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card class="ui-dialog-content">
                  <v-form ref="formProdutos"  v-if="produtosCategorias && produtosCategorias.length">
                    <!-- centered -->
                    <v-tabs
                      next-icon="chevron_right"
                      prev-icon="chevron_left"
                      show-arrows
                      class="ui-tabs ui-tabs-big"
                      v-model="tabsProdutos">
                      <v-tab v-for="categoria in produtosCategorias" :key="categoria.uuid_cat_id">
                        <v-icon class="mr-1">{{categoria.cat_id > 7 ? `mdi-${categoria.cat_icone}` : categoria.cat_icone}}</v-icon> {{categoria.cat_nome}}
                      </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tabsProdutos" class="ui-tabs-inherit">
                      <!-- KITS -->
                      <v-tab-item class="px-1">
                        <v-card class="px-3 pb-2 mb-3 pt-1">
                          <v-data-table
                            multi-sort
                            class="elevation-1 base_table mt-4"
                            loading-text="Carregando... Por favor aguarde"
                            :loading="carregando"
                            v-model="kitsSelecionados"
                            :headers="headersKitsSelect"
                            :search="searchKits"
                            :items="produtosCategorias[0].produtos"
                            item-key="kit_id"
                            show-select
                            :footer-props="{
                              itemsPerPageIcon: 'check_box_outline_blank',
                              itemsPerPageOptions: [5,10,15,20,25,50,100],
                              firstIcon: 'skip_previous',
                              lastIcon: 'skip_next',
                              prevIcon: 'chevron_left',
                              nextIcon: 'chevron_right'
                            }"
                            :header-props="{
                              sortIcon: 'north',
                            }"
                          >
                            <template v-slot:top>
                              <div class="py-2 px-2 table_search_area">
                                <v-text-field
                                  clearable
                                  hide-details=""
                                  clear-icon="close"
                                  v-model="searchKits"
                                  outlined
                                  label="Busca"
                                ></v-text-field>
                              </div>
                            </template>
                            <template v-slot:header.data-table-select="{ props, on }">
                              <v-simple-checkbox
                                color="primary"
                                v-if="props.indeterminate"
                                off-icon="check_box_outline_blank"
                                on-icon="check_box"
                                indeterminate-icon="indeterminate_check_box"
                                v-ripple
                                v-bind="props"
                                :value="props.indeterminate"
                                v-on="on"
                              ></v-simple-checkbox>
                              <v-simple-checkbox
                                color="primary"
                                v-if="!props.indeterminate"
                                v-ripple
                                off-icon="check_box_outline_blank"
                                indeterminate-icon="indeterminate_check_box"
                                on-icon="check_box"
                                v-bind="props"
                                v-on="on"
                              ></v-simple-checkbox>
                            </template>
                            <template v-slot:item.data-table-select="{ isSelected, select, item }">
                              <v-simple-checkbox
                                :value="isSelected"
                                @input="select($event)"
                                off-icon="check_box_outline_blank"
                                indeterminate-icon="indeterminate_check_box"
                                on-icon="check_box"
                              ></v-simple-checkbox>
                            </template>
                            <template v-slot:item.kit_valor="{ item }">
                              {{ $root.Formatter.floatToMoney(item.kit_valor) }}
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-tab-item>
                      <!-- FIM KITS -->
                      <v-tab-item class="px-1" v-if="indexCatProd > 0" v-for="(produtoCategoria, indexCatProd) in produtosCategorias" :key="produtoCategoria.uuid_cat_id + produtoCategoria.cat_id">
                        <v-card class="px-3 pb-2 mb-3 pt-1">
                          <v-data-table
                            multi-sort
                            class="elevation-1 base_table mt-4"
                            loading-text="Carregando... Por favor aguarde"
                            :loading="carregando"
                            v-model="produtosSelecionados"
                            :headers="headersProdutosSelect"
                            :search="searchProdutos[indexCatProd]"
                            :items="produtoCategoria.produtos"
                            item-key="pro_id"
                            show-select
                            :footer-props="{
                              itemsPerPageIcon: 'check_box_outline_blank',
                              itemsPerPageOptions: [5,10,15,20,25,50,100],
                              firstIcon: 'skip_previous',
                              lastIcon: 'skip_next',
                              prevIcon: 'chevron_left',
                              nextIcon: 'chevron_right'
                            }"
                            :header-props="{
                              sortIcon: 'north',
                            }"
                          >
                            <template v-slot:top>
                              <div class="py-2 px-2 table_search_area">
                                <v-text-field
                                  clearable
                                  hide-details=""
                                  clear-icon="close"
                                  v-model="searchProdutos[indexCatProd]"
                                  outlined
                                  label="Busca"
                                ></v-text-field>
                              </div>
                            </template>
                            <template v-slot:header.data-table-select="{ props, on }">
                              <v-simple-checkbox
                                color="primary"
                                v-if="props.indeterminate"
                                off-icon="check_box_outline_blank"
                                on-icon="check_box"
                                indeterminate-icon="indeterminate_check_box"
                                v-ripple
                                v-bind="props"
                                :value="props.indeterminate"
                                v-on="on"
                              ></v-simple-checkbox>
                              <v-simple-checkbox
                                color="primary"
                                v-if="!props.indeterminate"
                                v-ripple
                                off-icon="check_box_outline_blank"
                                indeterminate-icon="indeterminate_check_box"
                                on-icon="check_box"
                                v-bind="props"
                                v-on="on"
                              ></v-simple-checkbox>
                            </template>
                            <template v-slot:item.data-table-select="{ isSelected, select, item }">
                              <v-simple-checkbox
                                :value="isSelected"
                                @input="select($event)"
                                off-icon="check_box_outline_blank"
                                indeterminate-icon="indeterminate_check_box"
                                on-icon="check_box"
                              ></v-simple-checkbox>
                            </template>
                            <template v-slot:item.pro_preco_venda="{ item }">
                              {{item.pro_valor_tabela ? $root.Formatter.floatToMoney(item.pro_valor_tabela) : $root.Formatter.floatToMoney(item.pro_preco_venda)}}
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-form>
                  <v-divider></v-divider>
                  <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                    <v-btn
                      color="cancel"
                      :loading="salvando"
                      :disabled="salvando"
                      @click="closeDialogProdutosSemCadastro()"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click="selecionaProdutos()"
                      :loading="salvando"
                      :disabled="salvando"
                    >
                      Selecionar
                    </v-btn>
                  </v-row>
                </v-card>
              </v-dialog>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            {{ validaPermissaoEditarExcluir(kit) ? 'Cancelar' : 'Voltar' }}
          </v-btn>
          <v-btn
            v-if="validaPermissaoEditarExcluir(kit)"
            color="primary"
            @click="saveEditKits()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogDistribuidor"
      persistent
      max-width="400px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Selecione o distribuidor
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogDistribuidor()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formDistribuidor">
          <v-autocomplete
            v-model="distribuidor.uuid_dis_id"
            autocomplete="off"
            :items="distribuidores"
            :rules="[rules.required]"
            :loading="salvando || loadingDistribuidores"
            :disabled="salvando || loadingDistribuidores"
            label="Distribuidor*"
            append-icon="expand_more"
            outlined
          ></v-autocomplete>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialogDistribuidor()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="selecionaDistribuidor(true)"
            :loading="salvando || loadingDistribuidores"
            :disabled="salvando || loadingDistribuidores"
          >
            Selecionar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAlterarDistribuidor" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Alterar distribuidor
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogAlterarDistribuidor = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja alterar o distribuidor? <br><br>
          <b>Esta ação removerá todos os produtos já selecionados</b>
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogAlterarDistribuidor = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="confirmaAlterarDistribuidor()"
          >
            Alterar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Kit
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelKitDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir kit <b class="text-primary">{{kit ? kit.kit_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelKitDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeKit()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Api from '@API'
export default {
  data () {
    return {
      user: null,
      loading: true,
      salvando: false,
      dialogExcluir: false,
      carregando: false,
      search: '',
      searchProdutos: [],
      tabs: 0,
      total: 0,
      options: {},
      dialog: false,
      produtosCategorias: [],
      optionsMoney: {
        locale: 'pt-BR',
        prefix: 'R$',
        suffix: '',
        length: 10,
        precision: 2
      },
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'kit_id',
          width: 150
        },
        { text: 'Nome', value: 'kit_nome' },
        { text: 'Valor total em produtos', value: 'kit_produtos_total' },
        { text: 'Valor informado do kit', value: 'kit_valor' },
        { text: 'Distribuidor', value: 'distribuidor_nome' },
        { text: 'Integrador', value: 'integrador_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!'
      },
      kit: {
        kit_nome: '',
        kit_referencia: '',
        uuid_dis_id: '',
        uuid_int_id: null,
        kit_descricao: '',
        kit_valor: ''
      },
      loadingDistribuidores: false,
      loadingRevendedores: false,
      loadingIntegradores: false,
      distribuidores: [],
      integradores: [],
      distribuidor: {
        uuid_dis_id: ''
      },
      distribuidorSelecionado: null,
      integradorSelecionado: null,
      dialogAlterarDistribuidor: false,
      dialogDistribuidor: false,
      dialogProduto: false,
      dialogSelecionaProduto: false,
      headersProdutos: [
        { text: 'Categoria', value: 'pro_categoria' },
        { text: 'Nome', value: 'pro_nome' },
        { text: 'Preço de venda', value: 'pro_preco_venda' },
        { text: 'Preço Total', value: 'total' },
        { text: 'Quantidade', value: 'pro_quantidade', align: 'center' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosProdutos: [],
      headersProdutosSelect: [
        { text: 'Nome', value: 'pro_nome' },
        { text: 'Marca', value: 'marca.mar_nome' },
        { text: 'Modelo', value: 'modelo.mod_nome' },
        { text: 'Preço de venda', value: 'pro_preco_venda' }
      ],
      kitsSelecionados: [],
      headersKitsSelect: [
        { text: 'Nome', value: 'kit_nome' },
        { text: 'Descrição', value: 'kit_descricao' },
        { text: 'Preço de venda', value: 'kit_valor' }
      ],
      searchKits: '',
      produtosSelecionados: [],
      tabsProdutos: -1,
      dialogRemoveProduto: false,
      produtoRemover: {},
      categoriasProdutos: [],
      loadingCategorias: false,
      totalKit: 0,
      listaClientes: [],
      loadingCliente: false,
      serchField: null,
      searchClient: null
    }
  },
  watch: {
    options: {
      handler () {
        this.getKits()
      },
      deep: true
    },
    dadosProdutos () {
      this.totalKit = 0
      this.dadosProdutos.map(produto => {
        let valor = produto.pro_valor_tabela ? produto.pro_valor_tabela : produto.pro_preco_venda
        this.totalKit += produto.pro_quantidade * valor
        if (!this.kit.kit_id) {
          this.kit.kit_valor = this.totalKit
        }
      })
    },
    searchClient (val) {
      this.serchField = val
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(),
        busca: this.search,
        type: 'kits'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários' && header.text !== 'Imagem') cabecalhos.push(header)
      })
      return cabecalhos
    },
    removeHeader () {
      if (this.$root.Permissions.distributor()) {
        delete this.headers[4]
        delete this.headers[5]
      }
      if (this.$root.Permissions.integrator()) {
        delete this.headers[5]
      }
    },
    async loadFunctions () {
      this.removeHeader()
      let filters = this.$route.query
      if (filters.busca) this.search = filters.busca
      if (filters.distribuidor) this.distribuidorSelecionado = filters.distribuidor

      await this.getCategorias()
      await this.getDistributors()
      await this.getIntegrators()

      // if (!this.distribuidorSelecionado && !this.$root.Permissions.distributor() && this.distribuidores.length > 0) {
      //   this.distribuidor = this.distribuidores[0].value
      // }

      if (this.$root.Permissions.distributor()) {
        this.selecionaDistribuidor()
      }

      this.loading = false
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    async getCategorias () {
      this.loadingCategorias = true
      await Api.get('produtos/categorias')
        .then(res => {
          let info = []
          if (res.data && res.data.length > 0) {
            info.push({
              cat_id: 0,
              text: 'Kits',
              value: 'kits',
              color: 'blue darken-4',
              quantidade: 0
            })
            res.data.map(item => {
              info.push({
                cat_id: item.cat_id,
                text: item.cat_nome,
                value: item.uuid_cat_id,
                color: item.cat_cor,
                quantidade: 0
              })
            })
          }
          this.categoriasProdutos = info
          this.loadingCategorias = false
        })
        .catch(err => {
          this.loadingCategorias = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as categorias!',
            color: 'error'
          })
          console.log(err)
        })
    },
    retornaNomeOuHifen (objeto, campo) {
      if (!objeto || !objeto[campo]) return '-'
      return objeto[campo]
    },
    async getKits () {
      this.carregando = true
      this.total = 0

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 1
      let endpoint = ''

      if (page) pagina = page
      if (itemsPerPage) itensPagina = itemsPerPage
      if (this.search) endpoint += `&busca=${this.search}`
      if (this.distribuidorSelecionado && !this.integradorSelecionado) endpoint += `&distribuidor=${this.distribuidorSelecionado}`
      if (this.integradorSelecionado) endpoint += `&integrador=${this.integradorSelecionado}`

      await Api.get(`kits?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          let info = []
          let totalRemovido = 0
          if (res.data && res.data.data.length > 0) {
            res.data.data.filter(item => {
              // if (!this.integradorSelecionado && this.distribuidorSelecionado && item.fk_int_id_integrador !== null) {
              //   console.log('aaaaaaa')
              //   totalRemovido++
              //   return false
              // }
              // if (this.integradorSelecionado && item.fk_dis_id_distribuidor !== null) {
              //   console.log('bbbbbbbbb')
              //   totalRemovido++
              //   return false
              // }
              return true
            }).map(item => {
              info.push({
                uuid_kit_id: item.uuid_kit_id,
                kit_id: item.kit_id,
                kit_nome: item.kit_nome,
                kit_valor: this.$root.Formatter.floatToMoney(item.kit_valor),
                kit_produtos_total: this.retornaValorProdutosKit(item),
                distribuidor_nome: !item.integrador ? this.retornaNomeOuHifen(item.distribuidor, 'dis_nome') : '-',
                integrador_nome: this.retornaNomeOuHifen(item.integrador, 'int_nome'),
                distribuidor: item.distribuidor,
                integrador: item.integrador
              })
            })
            this.total = res.data.total - totalRemovido
          }
          this.dados = info
          this.carregando = false
        })
        .catch(err => {
          console.log(err)
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os kits!',
            color: 'error'
          })
        })
    },
    retornaValorProdutosKit (kit) {
      if (kit.kit_produtos_total) return this.$root.Formatter.floatToMoney(kit.kit_produtos_total)
      let total = Number(kit.produtos_total) + Number(kit.subkits_produtos_total)
      return this.$root.Formatter.floatToMoney(total)
    },
    saveEditKits () {
      if (!this.$refs.formKits.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'kits/novo'
      let editado = false
      if (this.kit.uuid_kit_id) {
        endpoint = 'kits/edita'
        editado = true
      }

      this.kit.uuid_dis_id = this.distribuidor.uuid_dis_id

      if (this.$root.Permissions.integrator()) {
        this.kit.uuid_int_id = this.user.uuid_int_id
      }

      this.kit.produtos = this.dadosProdutos

      Api.post(endpoint, this.kit)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Kit atualizado com sucesso!' : 'Kit cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getKits()
        })
        .catch((error) => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeKit () {
      this.salvando = true
      Api.delete(`kits/remove/${this.kit.uuid_kit_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getKits()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover kit!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      let endpoint = ''
      if (this.distribuidorSelecionado) endpoint += '?distribuidor=' + this.distribuidorSelecionado

      Api.get(`kits/${item.uuid_kit_id}${endpoint}`)
        .then(res => {
          this.kit = res.data
          if (this.kit.distribuidor) {
            this.distribuidor.uuid_dis_id = this.kit.distribuidor.uuid_dis_id
          }
          this.selecionaDistribuidor()
          this.dadosProdutos = this.kit.produtos
          this.quantidadePorCategoria()
          this.dialog = true
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao buscar kit!',
            color: 'error'
          })
        })
    },
    openDialogDelete (item) {
      this.kit = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelKitDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    closeDialog () {
      this.kit = {
        kit_nome: '',
        kit_referencia: '',
        uuid_dis_id: '',
        uuid_int_id: '',
        kit_descricao: '',
        kit_valor: ''
      }
      if (this.$refs.formKits) {
        this.$refs.formKits.resetValidation()
      }
      this.distribuidor = {
        uuid_dis_id: ''
      }
      this.dadosProdutos = []
      this.resetQuantidadeCategoria()
      this.tabs = 0
      this.dialog = false
    },
    applyFilter () {
      this.carregando = true

      let query = Object.assign({},
        this.search ? { busca: this.search } : '',
        this.distribuidorSelecionado ? { distribuidor: this.distribuidorSelecionado } : ''
      )

      this.$router.replace({name: this.$route.name, query: query}).catch(() => {})

      this.options.page = 1
      this.getIntegrators()
      this.getKits()
    },
    async getDistributors () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores/distribuidores-vinculados')
        .then(res => {
          let info = []
          res.data.map(item => {
            info.push({
              value: item.uuid_dis_id,
              text: item.dis_nome_fantasia ? item.dis_nome_fantasia : item.dis_nome
            })
          })
          this.distribuidores = info
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegrators () {
      this.loadingIntegradores = true

      let endpoint = ''
      if (this.distribuidorSelecionado) endpoint += '&distribuidor=' + this.distribuidorSelecionado

      await Api.get(`integradores?${endpoint}`)
        .then(res => {
          let info = []
          res.data.map(item => {
            info.push({
              value: item.uuid_int_id,
              text: item.int_nome_fantasia ? item.int_nome_fantasia : item.int_nome
            })
          })
          this.integradores = info
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    closeDialogDistribuidor () {
      // this.distribuidor = {
      //   uuid_dis_id: ''
      // }
      this.dialogDistribuidor = false
    },
    async selecionaDistribuidor (abrirDialogProdutos = false) {
      this.salvando = true

      let distribuidor = ''
      if (this.$root.Permissions.distributor()) {
        distribuidor = this.user.uuid_dis_id
        this.distribuidor.uuid_dis_id = this.user.uuid_dis_id
      } else {
        distribuidor = this.distribuidor ? this.distribuidor.uuid_dis_id : ''
      }

      let endpoint = `produtos/distribuidor/${distribuidor}?show_kits=true`

      await Api.get(endpoint)
        .then(res => {
          this.dialogDistribuidor = false
          this.dialogSelecionaProduto = abrirDialogProdutos
          this.salvando = false
          this.produtosCategorias = res.data
        })
        .catch(err => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os produtos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    retornaCategoria (produto) {
      let categoria = this.categoriasProdutos.find(cat => cat.cat_id === produto.pro_categoria)
      if (!categoria && produto.fk_kit_id_kit) {
        categoria = this.categoriasProdutos[0]
      }
      if (!categoria) {
        categoria = {
          cat_id: 1000,
          text: 'Categoria removida',
          value: null,
          color: 'red accent-4'
        }
      }

      return categoria
    },
    quantidadePorCategoria () {
      this.categoriasProdutos.map(categoria => {
        categoria.quantidade = 0
      })

      this.dadosProdutos.map(produto => {
        let categoria = this.categoriasProdutos.find(cat => cat.cat_id === produto.pro_categoria)
        if (!categoria && produto.fk_kit_id_kit) {
          categoria = this.categoriasProdutos[0]
        }
        categoria.quantidade += produto.pro_quantidade
      })
    },
    resetQuantidadeCategoria () {
      this.categoriasProdutos.map(categoria => {
        categoria.quantidade = 0
      })
    },
    selecionaProdutos () {
      let produtosTodos = this.produtosSelecionados
      produtosTodos.map((pro) => {
        if (pro.pro_quantidade === 0) {
          pro.pro_quantidade = 1
        }
      })
      let kitsTodos = this.kitsSelecionados
      kitsTodos.map((kit) => {
        if (kit.pro_quantidade === 0) {
          kit.pro_quantidade = 1
        }
      })
      let novosProdutos = this.dadosProdutos.concat(this.produtosSelecionados)
      novosProdutos = novosProdutos.concat(this.kitsSelecionados)
      this.dadosProdutos = novosProdutos
      this.quantidadePorCategoria()
      this.closeDialogProdutosSemCadastro()
    },
    closeDialogProdutosSemCadastro () {
      this.produtosSelecionados = []
      this.kitsSelecionados = []
      this.dialogSelecionaProduto = false
      this.tabsProdutos = 0
    },
    aumentaQuantidadeProduto (item) {
      let produtosTodos = []
      produtosTodos = this.dadosProdutos
      produtosTodos.filter((pro) => {
        if (pro === item) {
          pro.pro_quantidade = pro.pro_quantidade + 1
        }
      })
      this.dadosProdutos = JSON.parse(JSON.stringify(produtosTodos))
      this.quantidadePorCategoria()
    },
    diminuiQuantidadeProduto (item) {
      let produtosTodos = []
      produtosTodos = this.dadosProdutos
      produtosTodos.filter((pro) => {
        if (pro === item) {
          pro.pro_quantidade > 1 ? (pro.pro_quantidade = pro.pro_quantidade - 1) : pro.pro_quantidade = 1
        }
      })
      this.dadosProdutos = JSON.parse(JSON.stringify(produtosTodos))
      this.quantidadePorCategoria()
    },
    confirmaRemoveProduto (item) {
      this.produtoRemover = item
      this.dialogRemoveProduto = true
    },
    removeProdutoLista () {
      let produtosAutalizados = this.dadosProdutos.filter((pro) => pro.pro_nome !== this.produtoRemover.pro_nome)
      this.produtoRemover = {}
      this.dialogRemoveProduto = false
      this.dadosProdutos = produtosAutalizados
    },
    adicionaProdutoLista (item) {
      item.pro_quantidade = 1
      item.pro_id = null
      this.dadosProdutos.push(item)
      this.quantidadePorCategoria()
    },
    openCloseDialog () {
      this.dialogProduto = !this.dialogProduto
      return this.dialogProduto
    },
    validaPermissaoEditarExcluir (item) {
      if (!item.uuid_kit_id) return true
      if ((item.fk_int_id_integrador || item.integrador) && this.$root.Permissions.integrator()) return true
      if ((item.fk_dis_id_distribuidor || item.distribuidor) && this.$root.Permissions.distributor()) return true
      return false
    },
    confirmaAlterarDistribuidor () {
      this.distribuidor = {
        uuid_dis_id: ''
      }
      this.dadosProdutos = []
      this.dialogAlterarDistribuidor = false
      this.resetQuantidadeCategoria()
      this.openDialogDistribuidor()
    },
    openDialogDistribuidor () {
      console.log(this.distribuidor, 'this.distribuidor')
      if (this.distribuidor.uuid_dis_id === '') {
        this.getDistributors()
        this.dialogDistribuidor = true
      } else {
        this.selecionaDistribuidor(true)
      }
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.kits_chip {
  width: 120px;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Kits.vue